import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Heart, Package, User } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const Login = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/account", { replace: true });
  }, [loading, user, navigate]);

  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main className="max-w-md mx-auto px-6 mt-16 min-h-[55vh] fade-up">
      <div className="bg-white rounded-2xl border border-[#0e2a1e]/8 p-8 text-center">
        <h1 className="font-serif-brand text-3xl font-semibold text-[#0e2a1e]">Welcome</h1>
        <p className="text-sm text-[#0e2a1e]/60 mt-2">
          Sign in to track your orders &amp; bookings and save your favourites.
        </p>

        <button
          onClick={handleGoogle}
          className="mt-8 w-full bg-white border border-[#0e2a1e]/15 text-[#0e2a1e] font-medium py-3 rounded-full hover:bg-[#0e2a1e] hover:text-[#f4f2ea] transition-colors flex items-center justify-center gap-3"
        >
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/></svg>
          Continue with Google
        </button>

        <div className="grid grid-cols-3 gap-3 mt-8 text-[#0e2a1e]/60">
          <div className="flex flex-col items-center gap-1"><Package size={18} /><span className="text-[11px]">Order history</span></div>
          <div className="flex flex-col items-center gap-1"><User size={18} /><span className="text-[11px]">Faster checkout</span></div>
          <div className="flex flex-col items-center gap-1"><Heart size={18} /><span className="text-[11px]">Save favourites</span></div>
        </div>
      </div>
      <p className="text-center text-xs text-[#0e2a1e]/40 mt-6">
        <Link to="/" className="hover:underline">← Back to home</Link>
      </p>
    </main>
  );
};

export default Login;
